module.exports = __webpack_public_path__ + "img/NorthDash_TitleAcelin.b971d2b7.png";